module.exports = __webpack_public_path__ + "img/第6章_1-2_名片與簽名.jpg";